module.exports = __webpack_public_path__ + "img/Main3.6d3414e7.jpg";